import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHospitalConfig, fetchPayerConfig } from '../../../store/actions/mailBoxAction';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import PayerConfiguration from './PayerConfiguration';
import './mailbox.less';
import { RootState } from '../../../store';
import { MailboxType } from '../../../store/models/mailBoxModel';

const ConfiguredPayerList = (): ReactElement => {
  const [payers, setPayers] = React.useState([]);
  const dispatch = useDispatch();
  const appDetail = ApplicationDetail.instance;
  const groupProviders = appDetail.getGroupProviders();
  const { centerId } =
    useSelector((state: RootState): MailboxType => state?.mailBox || {});

  useEffect((): any => {
    if (groupProviders?.length && centerId !== 0) {
      dispatch(fetchPayerConfig(centerId, onSuccessFetchPayerConfig, onErrorFetchPayerConfig));
      dispatch(fetchHospitalConfig(centerId, (): any => { }, (): any => { }));
    } else {
      dispatch(fetchPayerConfig(appDetail.getProviderId(), onSuccessFetchPayerConfig, onErrorFetchPayerConfig));
    }
  }, [centerId]);

  const onSuccessFetchPayerConfig = (payersList: any): any => {
      if (payersList?.length > 0) {
        setPayers(payersList);
      }
    };
  const onErrorFetchPayerConfig = (): any => {};

  return (
    <div className="tab-custom-container multipayer-tbl tbl-content w-100">
      {payers?.map((payer: any): any =>
        <PayerConfiguration payerDetails={payer} key={payer.payerID}/>,
      )}
    </div>
  );
};
export default ConfiguredPayerList;
